import { EnvironmentProviders, isDevMode } from '@angular/core';
import { provideStoreDevtools } from '@ngrx/store-devtools';

export const devToolProviders: EnvironmentProviders[] = [
    provideStoreDevtools({
        name: 'PN-FIT',
        maxAge: 25,
        logOnly: !isDevMode(),
    }),
];
